"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Toggle.css");
var player_react_toggle_1 = require("player-react-toggle");
var Utils = require("player-core/utils");
require("player-react-toggle/style.css");
var Toggle = (function (_super) {
    __extends(Toggle, _super);
    function Toggle(props) {
        var _this = _super.call(this, props) || this;
        _this._handleToggleChange = _this._handleToggleChange.bind(_this);
        _this._id = _this.props.id ? _this.props.id : 'inp' + Utils.createUUID();
        return _this;
    }
    Toggle.prototype._handleToggleChange = function () {
        if (this.props.onChange) {
            this.props.onChange(!this.props.checked, this._id);
        }
    };
    Toggle.prototype.getToggleSwitchProps = function () {
        var _a = this.props, name = _a.name, value = _a.value, isEnabled = _a.isEnabled, checked = _a.checked, displayIcons = _a.displayIcons;
        return {
            id: this._id,
            disabled: !isEnabled,
            name: name,
            value: value,
            icons: displayIcons,
            checked: checked
        };
    };
    Toggle.prototype.render = function () {
        var _a = this.props, tag = _a.tag, label = _a.label, isEnabled = _a.isEnabled, showLabel = _a.showLabel, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, isRequired = _a.isRequired, errorMessage = _a.errorMessage, description = _a.description;
        var labelClasses = ['label-text'];
        var cssOuter = ['p-toggle'];
        var accessibilityAttr = {};
        if (!isEnabled) {
            labelClasses.push('p-t-meta');
            cssOuter.push('is-disabled');
        }
        if (isRequired) {
            cssOuter.push('is-required');
        }
        if (errorMessage) {
            cssOuter.push('is-invalid');
        }
        if (!showLabel) {
            accessibilityAttr['aria-label'] = ariaLabel;
            cssOuter.push('label-hidden');
        }
        if (ariaLabelledBy && !label) {
            accessibilityAttr['aria-labelledby'] = ariaLabelledBy;
        }
        return (React.createElement("div", { className: cssOuter.join(' '), "data-tag": tag },
            React.createElement(player_react_toggle_1.default, __assign({}, this.getToggleSwitchProps(), accessibilityAttr, { onChange: this._handleToggleChange })),
            showLabel && label &&
                React.createElement("label", { htmlFor: this._id, className: labelClasses.join(' ') },
                    label,
                    isRequired && React.createElement("span", { className: "p-t-error50" }, "*")),
            (description || errorMessage) && React.createElement("div", null,
                description && React.createElement("p", { className: "note" }, description),
                errorMessage && React.createElement("p", { className: "error p-t-error50" }, errorMessage))));
    };
    return Toggle;
}(React.Component));
Toggle.defaultProps = {
    id: '',
    value: '',
    name: '',
    tag: null,
    label: '',
    checked: false,
    displayIcons: true,
    isEnabled: true,
    onChange: void (0),
    showLabel: true,
    isRequired: false,
    ariaLabel: '',
    ariaLabelledBy: '',
    errorMessage: '',
    description: ''
};
exports.default = Toggle;
//# sourceMappingURL=Toggle.js.map


//////////////////
// WEBPACK FOOTER
// ../player-toggle/build/control/Toggle.js
// module id = 332
// module chunks = 0